import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import type { TShowMoreButtonDesktop, IDepsDesktop } from './models';
import { ShowMoreButton as Component } from './show-more-button';
import styles from './styles/desktop.css';
import { TEXT_CONFIG } from './config';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const ShowMoreButtonDesktop = createWidget<IDepsDesktop, TShowMoreButtonDesktop>({
    styles,
    Text,
    textConfig: TEXT_CONFIG,
})(Component);
